const APIS = {
  BRANCH: "/logisticservice/api/branch/"
};

export default APIS;